"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _Clickable = _interopRequireDefault(require("../Clickable"));

var _capitalize = _interopRequireDefault(require("../utils/capitalize"));

var _chainPropTypes = require("../utils/chainPropTypes");

var _IconButtonModule = _interopRequireDefault(require("./IconButton.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * Refer to the [Icons](/style/glyphs) section of the documentation
 * regarding the available icon options.
 */


var IconButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _clsx;

  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties(props, ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/_react["default"].createElement(_Clickable["default"], _extends({
    className: (0, _clsx2["default"])(_IconButtonModule["default"]['icon-btn'], (_clsx = {}, _defineProperty(_clsx, _IconButtonModule["default"]["icon-btn-color".concat((0, _capitalize["default"])(color))], color !== 'default'), _defineProperty(_clsx, _IconButtonModule["default"]['icon-btn-disabled'], disabled), _defineProperty(_clsx, _IconButtonModule["default"]["icon-btn-size".concat((0, _capitalize["default"])(size))], size !== 'medium'), _defineProperty(_clsx, _IconButtonModule["default"]['icon-btn-edgeStart'], edge === 'start'), _defineProperty(_clsx, _IconButtonModule["default"]['icon-btn-edgeEnd'], edge === 'end'), _clsx), className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/_react["default"].createElement("span", {
    className: _IconButtonModule["default"]['icon-btn-label']
  }, children));
});

IconButton.propTypes = {
  /**
    * The icon element.
    */
  // children: chainPropTypes(PropTypes.node, props => {
  //   const found = React.Children.toArray(props.children).some(
  //     child => React.isValidElement(child) && child.props.onClick,
  //   );
  //
  //   if (found) {
  //     return new Error(
  //       [
  //         'Material-UI: you are providing an onClick event listener ' +
  //           'to a child of a button element.',
  //         'Firefox will never trigger the event.',
  //         'You should move the onClick listener to the parent button element.',
  //         'https://github.com/mui-org/material-ui/issues/13957',
  //       ].join('\n'),
  //     );
  //   }
  //
  //   return null;
  // }),

  /**
    * Override or extend the styles applied to the component.
    * See [CSS API](#css) below for more details.
    */

  /**
    * @ignore
    */
  className: _propTypes["default"].string,

  /**
    * The color of the component. It supports those theme colors that make sense for this component.
    */
  color: _propTypes["default"].oneOf(['default', 'inherit', 'primary', 'secondary', 'accent']),

  /**
    * If `true`, the button will be disabled.
    */
  disabled: _propTypes["default"].bool,

  /**
    * If `true`, the  keyboard focus ripple will be disabled.
    * `disableRipple` must also be true.
    */
  disableFocusRipple: _propTypes["default"].bool,

  /**
    * If `true`, the ripple effect will be disabled.
    */
  disableRipple: _propTypes["default"].bool,

  /**
    * If given, uses a negative margin to counteract the padding on one
    * side (this is often helpful for aligning the left or right
    * side of the icon with content above or below, without ruining the border
    * size and shape).
    */
  edge: _propTypes["default"].oneOf(['start', 'end', false]),

  /**
    * The size of the button.
    * `small` is equivalent to the dense button styling.
    */
  size: _propTypes["default"].oneOf(['small', 'medium'])
};
var _default = IconButton;
exports["default"] = _default;